import { render, staticRenderFns } from "./comp-rtc-stream.vue?vue&type=template&id=a34347e8&scoped=true&lang=pug&"
import script from "./comp-rtc-stream.vue?vue&type=script&lang=js&"
export * from "./comp-rtc-stream.vue?vue&type=script&lang=js&"
import style0 from "./comp-rtc-stream.vue?vue&type=style&index=0&id=a34347e8&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a34347e8",
  null
  
)

export default component.exports